import React from "react"
import { WrapperLineTime, WrapperItem, Item__title, ItemParrafo } from "./style"
import Img1967 from "../../../assets/images/v2026/linetime/1967.webp"
import Img1975 from "../../../assets/images/v2026/linetime/1975.webp"
import Img1990 from "../../../assets/images/v2026/linetime/1990.webp"
import Img1999 from "../../../assets/images/v2026/linetime/1999.webp"
import Img2006 from "../../../assets/images/v2026/linetime/2006.webp"
import Img2011 from "../../../assets/images/v2026/linetime/2011.webp"
import Img2015 from "../../../assets/images/v2026/linetime/2015.webp"
import Img2017 from "../../../assets/images/v2026/linetime/2017.webp"
import Img2019 from "../../../assets/images/v2026/linetime/2019.webp"
import Img2026 from "../../../assets/images/v2026/linetime/2026.webp"
import { Theme } from "../../../styles/layoutcss"
import { SRLWrapper } from "simple-react-lightbox"
import Title from "../title"

const hitos = [
  {
    year: "1967",
    img: Img1967,
    text: "Es el año en que Agripino Coyuri se inicia en el mundo de las carrocerías para el transporte de pasajeros.",
  },
  {
    year: "1975",
    img: Img1975,
    text: "Uno de sus primeros trabajos como carrocero especializado fue en la Empresa Carrocera Espinar.",
  },
  {
    year: "1990",
    img: Img1990,
    text: "Forma parte de la conformación de Intramet S.A. ocupando el puesto de Jefe de producción, consolidando así su experiencia y liderazgo.",
  },
  {
    year: "1999",
    img: Img1999,
    text: "Inicia la etapa de emprendimiento con la sociedad empresarial INMECOT.",
  },
  {
    year: "2006",
    img: Img2006,
    text: "Inicia la etapa de consolidación al formar junto a sus hijos INTRAMET S.R.L. en el rubro de fabricación de carrocerías sobre chasis de las marcas más reconocidas tales como: Scania, Volvo y Mercedes Benz.",
  },
  {
    year: "2011",
    img: Img2011,
    text: "Fue el año de logros, año en que se compró la fábrica donde se diseñan y crean las carrocerías hasta el día de hoy.",
  },
  {
    year: "2015",
    img: Img2015,
    text: "Se firma una alianza estratégica con la empresa BUSIMPORT, por la cual pasa a formar parte del Grupo Corporativo Intramet. De esta manera garantizamos exclusividad, calidad y tecnología en el abastecimiento de partes y/o autopartes para el ensamblaje de carrocerías.",
  },
  {
    year: "2017",
    img: Img2017,
    text: "Consolidamos la conformación de nuestro Grupo Corporativo Intramet con la incorporación de la empresa ISERV, dedicada a la fabricación de asientos para buses. De esta manera garantizamos exclusividad, calidad y tecnología en el abastecimiento de asientos para buses.",
  },
  {
    year: "2019",
    img: Img2019,
    text: "Intramet exhibe sus carrocerías en otras ciudades del Perú logrando un gran posicionamiento y aceptación de las empresas de transporte.",
  },
  {
    year: "2026",
    img: Img2026,
    text: "INTRAMET cumple 20 años de fundación e inaugura una segunda planta de producción y servicios.",
  },
]

const hero = () => {
  return (
    <WrapperLineTime>
      <SRLWrapper>
        <div className="container card">
          <div data-aos="fade-up" data-aos-duration="1500">
            <Title color={Theme.colors.plomo} title="LÍNEA DE TIEMPO" />
          </div>
          {hitos.map((hito, key) => {
            // los hitos alternan imagen a la izquierda / a la derecha
            const imagen = (
              <div className="imageModal">
                <a href={hito.img}>
                  <img src={hito.img} alt={`Línea de tiempo ${hito.year}`} />
                </a>
              </div>
            )
            const info = (
              <div className="item__info">
                <Item__title>{hito.year}</Item__title>
                <span>{hito.text}</span>
              </div>
            )
            const izquierda = key % 2 === 0
            return (
              <WrapperItem key={hito.year}>
                <div
                  data-aos={izquierda ? "fade-left" : "fade-right"}
                  data-aos-duration="1500"
                  className="item"
                >
                  {izquierda ? imagen : info}
                  {izquierda ? info : imagen}
                </div>
              </WrapperItem>
            )
          })}
          <ItemParrafo>
            <div data-aos="flip-up" data-aos-duration="1500" className="item">
              Desde entonces la empresa fue creciendo con visión empresarial de
              largo plazo. Capacitando a sus colaboradores en base a la
              excelencia para hacerle frente a la fuerte competencia.
            </div>
          </ItemParrafo>
        </div>
      </SRLWrapper>
    </WrapperLineTime>
  )
}
export default hero
